import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CustomFieldTypes = {
  TEXT: 't',
  DATE: 'd',
  DROPDOWN: 'm',
  CHECKBOX: 'b',
} as const

export type CustomFieldTypeEnum = Enum<typeof CustomFieldTypes>
